// Hamburger Menu Functionality
const header = document.querySelector(".header");
const hamburgerMenu = document.querySelector(".hamburger-menu");
const mobileNav = document.querySelector(".mobile-nav");
const mobileNavLinks = document.querySelectorAll(".mobile-nav__list a");

// Toggle menu when hamburger button is clicked
if (hamburgerMenu && mobileNav) {
  const closeMenu = () => {
    hamburgerMenu.classList.remove("active");
    header.classList.remove("active"); // Ovo ti je falilo!
    mobileNav.classList.remove("active");
    hamburgerMenu.setAttribute("aria-expanded", "false");
  };

  hamburgerMenu.addEventListener("click", () => {
    const isActive = hamburgerMenu.classList.toggle("active");
    header.classList.toggle("active");
    mobileNav.classList.toggle("active");
    hamburgerMenu.setAttribute("aria-expanded", isActive);
  });

  // Close menu when a link is clicked
  mobileNavLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      const href = link.getAttribute("href");

      // Call the closeMenu function to close the menu
      closeMenu();

      if (href.startsWith("#")) {
        e.preventDefault();
        const targetId = href.substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          setTimeout(() => {
            targetElement.scrollIntoView({ behavior: "smooth" });
          }, 100);
        }
      }
    });
  });

  // Close menu when clicking outside of it
  document.addEventListener("click", (e) => {
    const isClickInsideNav = mobileNav.contains(e.target);
    const isClickOnHamburger = hamburgerMenu.contains(e.target);

    if (
      !isClickInsideNav &&
      !isClickOnHamburger &&
      mobileNav.classList.contains("active")
    ) {
      hamburgerMenu.classList.remove("active");
      mobileNav.classList.remove("active");
      hamburgerMenu.setAttribute("aria-expanded", "false");
    }
  });

  // Close menu on Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && mobileNav.classList.contains("active")) {
      hamburgerMenu.classList.remove("active");
      mobileNav.classList.remove("active");
      hamburgerMenu.setAttribute("aria-expanded", "false");
    }
  });
}
